// ── 영업일 계산 유틸 (공휴일 캐시 + 다음 영업일) ─────────────────────────────
// holidayRef: useRef({}) 객체를 외부에서 전달받아 연도별 캐싱에 사용
// utils.js가 300줄로 꽉 차 있어 별도 파일로 분리

import { getKstNow, addKstDays, fmtYmd, isWeekend } from './utils';
import { toDateString } from '../../../utils/date';

/**
 * 공휴일 Set 조회 (연도별 캐싱)
 * @param {number} y         - 조회 연도
 * @param {React.MutableRefObject<object>} holidayRef - 연도 → Promise<Set> 캐시 ref
 * @returns {Promise<Set<string>>} YYYY-MM-DD 형식 공휴일 집합
 */
export async function holidaySet(y, holidayRef) {
  const key = String(y);
  if (holidayRef.current[key]) return holidayRef.current[key];
  const promise = fetch(`https://date.nager.at/api/v3/PublicHolidays/${y}/KR`)
    .then(async (res) => {
      if (!res.ok) return new Set();
      const rows = await res.json();
      return new Set((rows || []).map((x) => toDateString(x.date || '')).filter(Boolean));
    })
    .catch(() => new Set());
  holidayRef.current[key] = promise;
  return promise;
}

/**
 * 다음 영업일(주말·공휴일 제외) 계산
 * @param {React.MutableRefObject<object>} holidayRef - 공휴일 캐시 ref
 * @returns {Promise<string>} YYYY-MM-DD 형식 다음 영업일
 */
export async function nextBizDate(holidayRef) {
  let cur = addKstDays(getKstNow(), 1);
  for (let i = 0; i < 31; i += 1) {
    const ymd = fmtYmd(cur);
    // eslint-disable-next-line no-await-in-loop
    const holidays = await holidaySet(cur.getUTCFullYear(), holidayRef);
    if (!isWeekend(cur) && !holidays.has(ymd)) return ymd;
    cur = addKstDays(cur, 1);
  }
  return fmtYmd(cur);
}
